export const mapErrorToType = (error, source) => {
  console.log('Mapping error:', { error, source });

  const defaultMessage = 'An unexpected error occurred. Please try again later.';

  // Handle Offline Errors
  if (!navigator.onLine) {
    return {
      type: 'CRITICAL',
      message: 'You are offline. Please check your internet connection.',
    };
  }

  // Handle Network Errors
  if (source === 'Network' || error?.networkError) {
    const statusCode = error?.networkError?.statusCode || error?.networkError?.response?.status;

    switch (statusCode) {
      case 401:
      case 403:
        return {
          type: 'CRITICAL',
          message: 'You are not authorized to perform this action. Please log in and try again.',
        };

      case 500:
      case 502:
      case 503:
      case 504:
        return {
          type: 'CRITICAL',
          message: 'The server is currently unavailable. Please try again later.',
        };

      case 400:
      case 404:
        return {
          type: 'TOAST',
          message: 'A client-side error occurred. Please check your request.',
        };

      default:
        if (statusCode >= 400 && statusCode < 500) {
          return {
            type: 'TOAST',
            message: 'A client-side error occurred. Please check your request.',
          };
        }

        if (statusCode >= 500) {
          return {
            type: 'CRITICAL',
            message: 'The server encountered an error. Please try again later.',
          };
        }

        return {
          type: 'CRITICAL',
          message: 'A network error occurred. Please try again later.',
        };
    }
  }

  // Handle GraphQL Errors
  if (source === 'API' && error?.graphQLErrors?.length > 0) {
    const [graphQLError] = error.graphQLErrors;

    switch (graphQLError.extensions?.code) {
      case 'UNAUTHENTICATED':
        return {
          type: 'CRITICAL',
          message: 'Authentication is required. Please log in.',
        };

      case 'FORBIDDEN':
        return {
          type: 'CRITICAL',
          message: 'You do not have permission to perform this action.',
        };

      default:
        return {
          type: 'TOAST',
          message: graphQLError.message || defaultMessage,
        };
    }
  }

  // Fallback Error
  return {
    type: 'TOAST',
    message: error?.message || defaultMessage,
  };
};
